import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RelationshipService {

  constructor(private  httpClient: HttpClient) {
  }

  getRelationships() {
    return this.httpClient.get('/systemconfig/relationship/');
  }

  ///////////////////old////////////////////
  getRelationship(id) {
    return this.httpClient.get(`/systemconfig/relationship/${id}/`);
  }

  getRelationsships(id){
  return this.httpClient.get('/systemconfig/relationshipdetails/',{params:{id:id}})
  }


  postRelationship(relationship) {
    return this.httpClient.post('/systemconfig/relationship/', relationship);
  }

  //////////////////old//////////////////
  updateRelationship(id, relationship) {
    return this.httpClient.patch(`/systemconfig/relationship/${id}/`, relationship);
  }
  updateRelationships(relationship){
  return this.httpClient.post('/systemconfig/relationshipdetails/',relationship)
  }
}
